import React from 'react'
import DmtCommisionpStuc from '../../../components/dmtModule/disputes/dmt-commision-structure/DmtCommision'

function DmtCommisionpStucture() {
  return (
    <div><DmtCommisionpStuc/></div>
  )
}

export default DmtCommisionpStucture